// extracted by mini-css-extract-plugin
export default {"ourGames":"BrowseGamesSection-module--ourGames--03140","row":"BrowseGamesSection-module--row--ac262","game":"BrowseGamesSection-module--game--6a9d6"};